var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"font-weight-regular text-right"},[_vm._v(_vm._s(_vm.caption))]),_c('td',{staticClass:"pl-2 font-weight-bold text--primary"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }